import { Expose, instanceToPlain, plainToInstance, Transform } from 'class-transformer'
import type { MeResource as Model, MyPusher } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'
import { transformDate } from '@/functions/utils'
import type { TransformableDate } from '@/types/utility'
import { map } from 'lodash'
import MyOrganization from '@/services/api/transformers/MyOrganization'
import NavItem from '@/services/api/transformers/NavItem'
import MainNavMiscConfig from '@/services/api/transformers/MainNavMiscConfig'

export type SerializedMe = Model

export default class MeResource implements CamelCaseKeys<SerializedMe> {
    id!: Model['id']

    oid!: Model['oid']

    username!: Model['username']

    email!: Model['email']

    @Expose({ name: 'first_name' })
    firstName!: Model['first_name']

    @Expose({ name: 'last_name' })
    lastName!: Model['last_name']

    @Expose({ name: 'is_primary' })
    isPrimary!: Model['is_primary']

    @Expose({ name: 'tithely_id' })
    tithelyId!: Model['tithely_id']

    @Expose({ name: 'linked_person_id' })
    linkedPersonId!: Model['linked_person_id']

    @Expose({ name: 'created_on' })
    @Transform(({ value }) => transformDate(value))
    createdOn!: TransformableDate<Model['created_on']>

    @Expose({ name: 'last_active' })
    @Transform(({ value }) => transformDate(value))
    lastActive!: TransformableDate<Model['last_active']>

    features!: Model['features']

    @Expose({ name: 'mfa_status' })
    mfaStatus!: Model['mfa_status']

    @Expose({ name: 'email_verified' })
    emailVerified!: Model['email_verified']

    roles!: Model['roles']

    @Transform(({ value }) => plainToInstance(MyOrganization, value), { toClassOnly: true })
    @Transform(({ value }) => instanceToPlain(value), { toPlainOnly: true })
    organization!: MyOrganization

    preferences!: Model['preferences']

    pusher!: MyPusher

    @Expose({ name: 'send_from' })
    sendFrom!: Model['send_from']

    @Expose({ name: 'home_nav' })
    @Transform(({ value }) => (value ? plainToInstance(NavItem, value) : null), { toClassOnly: true })
    @Transform(({ value }) => (value ? instanceToPlain(value) : null), { toPlainOnly: true })
    homeNav!: NavItem | null

    @Expose({ name: 'main_nav' })
    @Transform(({ value }) => map(value, item => plainToInstance(NavItem, item)), { toClassOnly: true })
    @Transform(({ value }) => map(value, item => instanceToPlain(item)), { toPlainOnly: true })
    mainNav!: NavItem[]

    @Expose({ name: 'main_nav_misc_config' })
    @Transform(({ value }) => plainToInstance(MainNavMiscConfig, value), { toClassOnly: true })
    @Transform(({ value }) => instanceToPlain(value), { toPlainOnly: true })
    mainNavMiscConfig!: MainNavMiscConfig

    constructor(values: MeResource) {
        Object.assign(this, values)
    }
}
